/**
 * @file src/firebase/functions.js
 * @description Firebase Cloud Functions client for backend operations
 * 
 * Provides access to serverless functions running in Google Cloud.
 * Handles operations that require backend logic:
 * - Paymentverification (Stripe webhooks)
 * - Email sending (Resend) via mailer.js
 * - Scheduled delivery (nightly cron job)
 * - Custom auth claims (admin status)
 * - Billing portal access (Stripe)
 * - Unlock code verification (rate limiting)
 * 
 * Cloud Functions:
 *   - getDeliveryView: Decrypt and return capsule to public viewer
 *   - mailer: Send email notifications
 *   - stripeWebhook: Process Stripe payment events
 *   - scheduledDelivery: Nightly job to deliver past-due capsules
 *   - deleteAccount: Clean up user data on account deletion
 *   - billingPortal: Generate Stripe customer portal session
 *   - And more in functions/ directory
 * 
 * @exports
 *   - functions: Cloud Functions instance
 *   - httpsCallable: Factory to call Cloud Functions
 * 
 * @example
 *   import { functions, httpsCallable } from '../firebase/functions';
 *   
 *   const getDeliveryView = httpsCallable(functions, 'getDeliveryView');
 *   const { data } = await getDeliveryView({ viewToken });
 */

// src/firebase/functions.js
import { app } from "./firebaseConfig";
import { getFunctions, httpsCallable } from "firebase/functions";

const functions = getFunctions(app);

export { functions, httpsCallable };